
export default "/assets/envelope-open-micro.bfa63870.svg"